import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Card, Result } from "antd";
import styles from "./AgentError.module.scss";
const { agent, agentViewMobile, errorCard } = styles;
function AgentError({ logoutCb }) {
    const { t } = useTranslation();
    const isMobile = window.innerWidth < 1024;
    return (
        <div className={`${agent} ${isMobile && agentViewMobile}`}>
            <Card className={errorCard}>
                <Result
                    status="warning"
                    title={t("connection.error")}
                    extra={
                        <>
                            <p>{t("connection.errorDesc")}</p>
                            <Button onClick={() => window.location.reload()}>{t("reload")}</Button>
                            <Button onClick={() => logoutCb()}>{t("Logout")}</Button>
                        </>
                    }
                />
            </Card>
        </div>
    );
}

export { AgentError };
